<template lang="pug">
  div.password-form.mx-auto(@keydown.enter="onSetPassword")
    v-card.pa-6
      v-card-title
        v-icon(color="primary" size="32") settings
        h3.primary--text.ml-2 Passwort setzen

      v-form.mt-3(ref="password-form" lazy-validation @submit.prevent="() => {}")
        p.mb-4(v-if="userId") Bitte geben Sie das neue Passwort für den Benutzer an.

        v-text-field(
          v-model="form.password"
          label="Neues Passwort"
          type="password"
          append-icon="lock"
          outlined
          :rules="[ rules.required, rules.password ]"
        )

        v-text-field(
          v-model="form.password_repeat"
          label="Wiederholung"
          type="password"
          append-icon="lock"
          outlined
          :rules="[ rules.required, rules.password, rules.password_match(form.password) ]"
        )

        v-row.mt-3
          v-col(:cols="userId ? 6 : 12")
            v-btn(block color="primary" dark :loading="loading" @click="onSetPassword") Speichern

          v-col(v-if="userId" :cols="6")
            v-btn(block color="secondary" :disabled="loading" @click="$emit('saved')")
              span.primary--text Schließen

</template>

<script>
import { Vue, Component, Prop } from 'vue-property-decorator'

import Urls from '@/router/urls'
import FormMixin from '@/mixins/form'

@Component({
  mixins: [
    FormMixin
  ],

  watch: {
    userId () {
      this.form.password = ''
      this.form.password_repeat = ''
      this.resetForm('password-form')
    }
  }
})
export default class SetPassword extends Vue {
  @Prop({ type: String, default: '' }) token
  @Prop({ type: [ Number, String ], default: 0 }) userId

  form = {
    password: '',
    password_repeat: '',
  }

  loading = false

  onSetPassword () {
    if (!this.isFormValid('password-form')) {
      return
    }

    let requestUri = `${ Urls.User(this.userId) }set_password/`
    const params = {
      password: this.form.password,
      password_repeat: this.form.password_repeat
    }

    if (!this.userId) {
      params.token = this.token
      requestUri = Urls.Auth.SetPassword
    }

    this.loading = true
    this.$axios
      .put(requestUri, params)
      .then(() => {
        if (!this.userId) {
          return this.gotoRoute('login')
        }

        this.$toast.success('Passwort geändert', 'Speichern')
        this.$emit('saved')
      })
      .catch(err => {
        this.$toast.error(err.message, 'Fehler')
      })
      .finally(() => {
        this.loading = false
      })
  }
}
</script>

<style scoped>
.password-form {
  margin-top: 150px;
  max-width: 450px;
  width: 100%;
}
</style>
